import { ThemeProvider, createGlobalStyle } from 'styled-components/macro';

export const theme = {
  colors: {
    brandColor: '#154897',
    brandMedium: '#2571e9',
    brandLight: '#f1fbff',
    brandGreen: '#44a29a',
    brandBlack: '#404041',
    brandGradient: `linear-gradient(152.66deg, #2571e9 1.52%, #44a29a 97.13%)`,
    brandColorRgb: '21, 72, 151',
    grey1: '#B3B3B6',
    grey2: '#717171',
    grey3: '#e6e6e7',
    grey4: '#fafafa',
    grey5: '#aaaaaa',
    grey6: '#f5f5f5',
    grey7: '#d6d9dc',
    green: '#27AE60',
    yellow: '#F2C94C',
    red: '#EB5757',
    black: '#000000',
    white: '#FFFFFF',
    orange: '#F2994A',
    backdropColor: 'red',
    semiTransparentLightGray: 'rgba(223, 223, 223, 0.32)',
  },
  fonts: {
    family: {
      roboto: 'Roboto, sans-serif',
    },
    bold: '700',
  },
  shadows: {
    defaultLight: '0px 30px 60px rgba(0, 0, 0, 0.1)',
    defaultDark: '0px 27px 32px rgba(6, 57, 92, 0.2)',
    brandLight: '0px 20px 40px 0px rgba(83, 171, 220, 0.40)',
    brandDark: '0px 20px 40px 0px rgba(40, 121, 168, 0.4)',
  },
};

const Theme = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;

export default Theme;

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    font-family: 'Overpass', sans-serif;
  }
  .MuiCircularProgress-colorPrimary {
    color: #154897 !important;
  }
`;
